// ============================================================
// ReportCustomer00 — รายงานลูกค้าทั้งหมด
// ------------------------------------------------------------
// สร้างเอกสาร PDF ด้วย pdfmake แล้วเปิดในแท็บใหม่ด้วย openPdf()
// ตั้งค่า pdfmake + ฟอนต์ไทย อยู่ที่ documents/pdf.js (ใช้ร่วมกันทุกไฟล์ในโฟลเดอร์นี้)
// ============================================================

import { openPdf } from "../pdf.js";
import { loading, getStorage, replaceText } from "../../shared/index.js";

import "../../assets/css/bootstrap.css";
import "../../shared/config/global.js";

// เรียกปิด loading ทันทีตั้งแต่เข้ามาโหลดหน้า/ไฟล์นี้
loading(false);

// รายงานลูกบ้าน
async function report_customer_0(data) {
  loading(true); // เปิด loading เริ่มประมวลผล PDF

  const statusMap = { 1: "โอนแล้ว", 2: "ยังไม่โอน", 3: "ห้องว่าง" };

  let array = data.map((item, index) => [
    { text: index + 1, alignment: "center" },
    { text: item.building || "-", alignment: "center" },
    { text: item.address_number || "-", alignment: "center" },
    { text: item.full_name || "-", alignment: "left" },
    { text: item.room_size ? `${item.room_size} ตร.ม.` : "-", alignment: "center" },
    { text: statusMap[item.status_transfer] || "-", alignment: "center" },
    { text: "-", alignment: "left" },
  ]);

  const docDefinition = {
    content: [
      { text: "รายงานชื่อลูกค้า", alignment: "center", fontSize: 18, bold: true },
      { text: getStorage("project_name") || "", alignment: "center", fontSize: 18, bold: true },
      { text: " " },
      {
        table: {
          headerRows: 1,
          widths: ["6%", "7%", "9%", "32%", "15%", "16%", "15%"],
          body: [
            [
              { text: "ลำดับ", alignment: "center" },
              { text: "อาคาร", alignment: "center" },
              { text: "บ้านเลขที่", alignment: "center" },
              { text: "ชื่อ - สกุล", alignment: "center" },
              { text: "ขนาดห้อง", alignment: "center" },
              { text: "สถานะ", alignment: "center" },
              { text: "หมายเหตุ", alignment: "center" },
            ],
            ...array,
          ],
        },
      },
    ],
    defaultStyle: { font: "THSarabunNew", fontSize: 14, lineHeight: 0.9 },
    pageSize: "A4",
    pageMargins: [15, 15, 15, 15],
  };

  let textDocDefinition = await replaceText(docDefinition);
  
  loading(false); // ปิด loading เมื่อสร้างเสร็จพร้อมเปิดเอกสาร
  
  openPdf(textDocDefinition, `รายงานลูกบ้าน ${new Date().toISOString()}.pdf`);
}

export { report_customer_0 };